// extracted by mini-css-extract-plugin
module.exports = {"copy":"CopyToClipboard_copy__2k6KA","iconClass":"CopyToClipboard_iconClass__2MN7s"};